import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import {
  Box,
  Card,
  CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Container,
  Grid,
  Divider,
  Chip
} from '@mui/material';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineDot,
  TimelineOppositeContent,
  TimelineSeparator
} from '@mui/lab';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import ProfileMenu from '../ProfileMenu.js';
import { formatDate } from '../../../helper.js';


const merchantInfo = {
  name: 'Shopify Merchant',
  storeName: 'Merchant Store',
  subscriptionPlan: 'Pro Plan', // Aktueller Abonnementplan des Händlers
};

const styles = {
  root: {
    margin: '-12px',
    width: 'auto',
    overflowX: 'auto',
    '& .MuiTimelineOppositeContent-root': {
      flex: '1 !important',
    },
  },
  table: {
    minWidth: 650,
  },
  /**
   * Sticky Spalte der Charges-Tabelle. `#fff` war im Dark Mode eine hell
   * leuchtende Insel (18.73:1 gegen die Seite) und die Zellinhalte erbten
   * darauf `text.primary` — also weiss auf weiss. `background.paper` ist die
   * modusrichtige Fläche, im Light-Modus unverändert weiss.
   */
  label: {
    width: 200,
    background: 'background.paper',
    borderRight: 'solid 1px',
    borderRightColor: 'divider',
    position: 'sticky',
    left: 0,
    zIndex: 1,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
  },
  statusRow: {
    padding: '12px',
  },
  statusChip: {
    marginLeft: '16px',
    fontSize: '1rem',
  },
  /**
   * `lightgrey` (rgb(211,211,211)) blieb im Dark Mode stehen, während
   * `TimelineContent`/`TimelineOppositeContent` darauf `text.primary` erben —
   * 1.45:1. Der Wert wäre über eine Hex-Suche nie gefunden worden.
   *
   * `surfaceRecessed` folgt dem Modus. Im Light-Modus wird die Fläche dadurch
   * deutlich heller (#fafafa statt rgb(211,211,211)) — die Timeline setzt sich
   * dort also dezenter ab als vorher.
   */
  timeline: {
    backgroundColor: 'surfaceRecessed',
    margin: 0,
    paddingTop: '40px',
    '&.disabled': {
      opacity: .5,
    },
  },
};


export function ChargeTimeline({charge, subscription}) {

  let icon = <FiberManualRecordIcon 
    style={{
      color: (charge.status === 'active' || charge.status === 'accepted') ? 'green' : 'red'
    }}
  />

  return (<Box sx={styles.root}>
    <Typography sx={styles.statusRow}>
      Status: 
      <Chip
        icon={icon}
        label={charge.status}
        sx={styles.statusChip}
      />
    </Typography>
    <Divider />
    <Timeline className={charge.name === 'free' ? 'disabled' : null} sx={styles.timeline}>
      {subscription?.length > 0 &&
        <TimelineItem>
          <TimelineOppositeContent>
            <Typography color="text.secondary">
              {formatDate(subscription[0].currentPeriodEnd)}
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>Next billing ($ {parseFloat(charge.price).toFixed(2)})</TimelineContent>
        </TimelineItem>
      }
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography color="text.secondary">
            {formatDate(charge.activated_on)}
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>Charge activated</TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent>
          <Typography color="text.secondary">
            {formatDate(charge.created_at)}
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
        </TimelineSeparator>
        <TimelineContent>Charge created</TimelineContent>
      </TimelineItem>

    </Timeline>
  </Box>);
}


const ProfileChargesPage = () => {
  const charge = useSelector((state) => state.shop.shop.charge);


  useEffect(() => {
    console.log(charge)
  }, [charge]);

  return (
    <React.Fragment>
      <Grid container spacing={3} alignItems="flex-start" className="page-content" sx={styles.root}>
        <Grid size={12} className="page-content">
          <Typography variant="h4" component="h2">My Charges</Typography>
          <Divider className="divider-white" />
        </Grid>
        <Grid size={{ xs: 12, md: 9 }}>
          <Paper sx={styles.paper}>
            <ChargeTimeline
              charge={charge}
            />
          </Paper>
        </Grid>
        <Grid size={{ xs: 0, md: 3 }} sx={{ display: { xs: 'none', md: 'block' } }}>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default (ProfileChargesPage);
